<template>
  <div class="form form--add-project">
    <div class="form__inner">
      <div class="form__title">Add New Project</div>
      <div class="form__input">
        <input type="text" v-model="projectTitle" name="Project Title"/>
        <label class="form__label" for="Project Title">Project Name</label>
      </div>
      <div class="form__select">
        <select name="Project Repo" v-model="projectGithubUrl" placeholder="project repo">
          <option value="null" selected>Select Project Repo</option>
          <option v-for="repo in repos" v-bind:key="repo.id" :value="repo.html_url">{{repo.name}}</option>
        </select>
        <IconCaretDown class="icon--caret-down"></IconCaretDown>
        <label class="form__label" for="Project Repo">Project Repo</label>
      </div>
      <IconCross class="form__button--close" v-on:click.native="toggleAddingProject()" />
      <div class="form__button--submit" v-on:click="addProject">Submit</div>
    </div>
  </div>
</template>

<script>
import axios from "axios";

import VueSelect from "vue-select";
import IconCaretDown from "@/components/icons/IconCaretDown.vue";
import IconCross from "@/components/icons/IconCross.vue";
export default {
  data() {
    return {
      repos: [],
      projectTitle: "",
      projectGithubUrl: ""
    };
  },
  components: {
    IconCaretDown,
    IconCross,
    VueSelect
  },
  beforeCreate() {
    if (localStorage.getItem("githubCredentials")) {
      this.githubCredential = JSON.parse(
        localStorage.getItem("githubCredentials")
      );
      const instance = axios.create({
        baseURL: "https://api.github.com/",
        timeout: 10000,
        headers: {
          Authorization: `token ${this.githubCredential.credential}`
        }
      });
      instance.get("/user/repos?sort=updated").then(response => {
        this.repos = response.data;
      });
    } else {
      this.$router.push("/login");
    }
  },
  methods: {
    toggleAddingProject() {
      this.$emit("toggle-adding-project");
    },
    addProject() {
      this.$emit("toggle-adding-project");
      this.$emit("add-project", {
        title: this.projectTitle,
        githubUrl: this.projectGithubUrl,
        id: this._uid,
        todos: []
      });
    }
  }
};
</script>

<style lang="scss">
.form {
  box-sizing: border-box;
  padding: 75px;
  border-bottom: 1px solid $mono-100;
  &__inner {
    @include container;
    display: grid;
    grid-gap: 20px;
  }
  &__title {
    font-size: 24px;
    font-weight: 700;
  }
  &__input {
    position: relative;
    margin-bottom: 20px;
    transition: border 0.2s ease;
    color: $mono-100;
    border-bottom: 1px solid $mono-100;
    background: $mono-0;
    &:focus-within {
      &:after {
        transform: scaleX(1);
      }
      .form__label {
        color: $mono-100;
      }
    }
    &:after {
      position: absolute;
      right: 0;
      bottom: 0;
      left: 0;
      content: "";
      transition: all 0.2s ease;
      transform: scaleX(0);
      transform-origin: 0 50%;
      border-bottom: 2px solid $mono-100;
    }
    > input {
      all: unset;
      width: 100%;
      padding: 5px 0;
    }
  }
  &__select {
    position: relative;
    z-index: 1;
    margin-bottom: 20px;
    border-bottom: 1px solid $mono-100;
    border-left: 1px solid $mono-100;
    .icon--caret-down {
      @include icon-size(14px);
      position: absolute;
      z-index: 0;
      top: 50%;
      right: 0;
      margin-top: -7px;
      pointer-events: none;
      fill: $mono-100;
    }
    > select {
      all: unset;
      z-index: 1;
      width: 100%;
      padding: 5px;

      appearance: none;
    }
    .selected-tag {
      color: $mono-100;
    }
    .dropdown-menu {
      border: none;
      background: $mono-0;

      appearance: none;
      > li {
        color: $mono-100;
      }
    }
  }
  &__label {
    font-size: 12px;
    font-weight: 500;
    position: absolute;
    bottom: -20px;
    left: 0;
    transition: all 0.2s ease;
    letter-spacing: 4.29px;
    text-transform: uppercase;
    color: $mono-53;
  }
  &__button {
    &--close {
      @include icon-size(24px);
      position: absolute;
      top: 20px;
      right: 20px;
      cursor: pointer;
      fill: $mono-100;
      &:hover {
        opacity: 0.8;
      }
    }
    &--submit {
      font-weight: 500;
      justify-self: end;
      padding: 10px 20px;
      cursor: pointer;
      user-select: none;
      letter-spacing: 2px;
      text-transform: uppercase;
      border: 2px solid $mono-100;
      &:hover {
        opacity: 0.8;
      }
    }
  }
}
</style>
